import { addPopupAction, LAYER } from 'js/components/common/PopupManager';
import { BonusBuyInPopup } from './BonusBuyInPopup';
import uuid from 'uuid-random';

const bonusBuyInId = uuid();

export const showBonusBuyInPopupAction = (props) => addPopupAction({
    ...props,
    id: bonusBuyInId,
    component: BonusBuyInPopup,
    layer: LAYER.BUY_IN_BONUS
});
